module.exports = Object.freeze({
  TO: "TO",
  FROM: "FROM",
});
